import purify from "dompurify"

export default function displayFlash(text, type) {
  let $flash = $(".flash-msg")

  if ($flash.length === 0) {
    $flash = $("<div>")
    $("body").append($flash)
  }

  $flash
    .attr({ class: `flash-msg ${type ? type : "alert"}` })
    .text(purify.sanitize(text))
    .fadeIn()

  setTimeout(() => {
    $(".flash-msg").not(".sticky").fadeOut()
  }, 4000)
}
